import React from "react";

const AIIcon = ({ fill = TB.config('color.primary'), size = 20,...props }) => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
             width={size} height={size} viewBox="0 0 200.000000 200.000000"
             className={props.className}
             preserveAspectRatio="xMidYMid meet">
            <g transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
               fill={fill} stroke="none">
                <path d="M797 1820 c-4 -25 -13 -93 -21 -151 -39 -280 -115 -356 -395 -395
-217 -30 -206 -27 -121 -35 233 -24 328 -52 398 -114 76 -69 106 -156 133
-390 l13 -110 12 110 c31 276 70 367 183 429 58 31 193 62 318 72 86 7 115 24
41 24 -60 0 -222 26 -287 45 -166 50 -222 148 -255 443 -11 103 -13 112 -19
72z"/>
                <path d="M1473 1055 c-13 -97 -42 -165 -78 -189 -26 -17 -108 -39 -190 -52
l-50 -8 70 -8 c133 -16 198 -51 225 -123 6 -16 17 -68 24 -115 l13 -85 7 60
c23 190 71 243 239 262 31 3 57 9 57 13 0 4 -26 10 -57 13 -83 9 -128 24 -163
53 -43 37 -51 55 -69 167 l-16 99 -12 -87z"/>
                <path d="M1167 507 c-10 -99 -44 -131 -162 -153 l-40 -7 59 -9 c96 -13 132
-48 143 -136 6 -54 23 -62 23 -11 0 77 52 135 131 145 66 9 70 20 9 27 -71 9
-105 29 -124 77 -9 22 -16 50 -17 63 0 12 -4 31 -8 42 -6 14 -9 3 -14 -38z"/>
            </g>
        </svg>
    )
}
export default AIIcon;